import { Component, OnInit } from '@angular/core';
import { faAngry, faFrown, faSmile, faSmileBeam, faLaughBeam } from '@fortawesome/free-solid-svg-icons';
import { gutil} from '../gutil';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-csat',
  templateUrl: './csat.component.html',
  styleUrls: ['./csat.component.scss']
})
export class CsatComponent implements OnInit {

  public faAngry = faAngry;
  public faFrown = faFrown;
  public faSmile = faSmile;
  public faSmileBeam = faSmileBeam;
  public faLaughBeam = faLaughBeam;
  public paramsData : any;
  public csat = {property_id:0, user_id:0, touchpoint:7, rating:0, comment:"", status: 0};
  public pid :  any;

  public form_msg:boolean = false;
  public form_err_msg: boolean = false;
  public form_submit_msg:any; 
  public form_error_msg: any;
  

  constructor(private http: HttpClient, private routeact: ActivatedRoute) { 
    this.paramsData = routeact.snapshot.params;
    this.csat.user_id = this.paramsData.uid;
    this.csat.property_id = this.paramsData.pid;
    
  }

  ngOnInit(): void {

  }

  public selectFeedbackRate(value:any) {    
    this.csat.rating = value;
  }
  public changeComment(value: any) {    
    this.csat.comment = value;
  }  

  public submitForm() {        
    let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    let options =  {headers: headers };
    let params = new URLSearchParams();
    
    for (let key in this.csat) {
      params.append(key, this.csat[key]);
  }
  
    let paramsString = params.toString();    
    if(this.csat.comment != "" && this.csat.rating != null ) {
        this.http.post('https://api.yourownroom.com/api/w/v1/csat/tenant/addedit', paramsString, options).subscribe((data: any) => {
          this.form_msg = true;
          this.form_submit_msg = "Thank You for your feedback!"
          this.confNotf();
          
          this.csat.comment = "";
          this.csat.rating = 0;      
        })
    }
    else {
      this.form_err_msg = true;
      this.form_submit_msg = "Please give your feedback!";     
      this.confNotf(); 
    }
      
  }

  public confNotf() {
    setTimeout(() => {
      this.form_msg = false;
      this.form_err_msg = false;
  }, 3000)
  }
}
